import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import { DashboardOutlined, BarChartOutlined, LineChartOutlined } from '@ant-design/icons';
import Dashboard from '../Dashboard/Dashboard';
import Insights from '../Insights/Insights';
import PerformanceDashboard from '../ClinicsPerformance/ClinicsPerformance';

const AnalysisScreen = () => {
    const [activeTab, setActiveTab] = useState('dashboard');

    const tabItems = [
        {
            key: 'dashboard',
            label: (
                <span className="flex items-center gap-2">
                    <DashboardOutlined />
                    Dashboard
                </span>
            ),
            children: <Dashboard />,
        },
        {
            key: 'insights',
            label: (
                <span className="flex items-center gap-2">
                    <BarChartOutlined />
                    Insights
                </span>
            ),
            children: <Insights />,
        },
        {
            key: 'performance',
            label: (
                <span className="flex items-center gap-2">
                    <LineChartOutlined />
                    Performance
                </span>
            ),
            children: <PerformanceDashboard />,
        },
    ];

    return (
        <div className="min-h-screen bg-[#F7FCFD]">
            <div className=" md:p-4">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                    />
            </div>
        </div>
    );
};

export default AnalysisScreen;